import { render, staticRenderFns } from "./WasteAndRecycling.vue?vue&type=template&id=fbbc2ff6&scoped=true&"
import script from "./WasteAndRecycling.vue?vue&type=script&lang=js&"
export * from "./WasteAndRecycling.vue?vue&type=script&lang=js&"
import style0 from "./WasteAndRecycling.vue?vue&type=style&index=0&id=fbbc2ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbc2ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbbc2ff6')) {
      api.createRecord('fbbc2ff6', component.options)
    } else {
      api.reload('fbbc2ff6', component.options)
    }
    module.hot.accept("./WasteAndRecycling.vue?vue&type=template&id=fbbc2ff6&scoped=true&", function () {
      api.rerender('fbbc2ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/assessments/WasteAndRecycling.vue"
export default component.exports